// context/TimeTrackContext.tsx
import React, {createContext, useContext, useState} from 'react'

interface TimeTrackContextType {
  timeTrackedData: any[]
  setTimeTrackedData: React.Dispatch<React.SetStateAction<any[]>>
}

const TimeTrackContext = createContext<TimeTrackContextType | undefined>(undefined)

export const TimeTrackProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [timeTrackedData, setTimeTrackedData] = useState<any[]>([])

  return (
    <TimeTrackContext.Provider value={{timeTrackedData, setTimeTrackedData}}>
      {children}
    </TimeTrackContext.Provider>
  )
}

// Hook for easier use
export const useTimeTrack = (): TimeTrackContextType => {
  const context = useContext(TimeTrackContext)
  if (!context) throw new Error('useTimeTrack must be used within a TimeTrackProvider')
  return context
}
